// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"edec8554","472":"b6eaa2bd","601":"168949bc","675":"a8ff10c4","692":"aff9cb57"}[chunkId] + ".chunk.js";
};